import React from 'react';
import classNames from 'classnames';
import Icon from 'components/Icon';
import Style from './ResumeWithoutProfile.module.scss';

const ResumeWithoutProfile = ({ isActive, theme, backgroundInline, play, restart }) => {
  const innerContainerStyle = backgroundInline && { ...backgroundInline };

  const { global_restartButton: labelRestart } = window.Language;

  return (
    isActive && (
      <div
        className={classNames(Style.resumeWithoutProfile, theme.resumeWithoutProfile)}
        style={innerContainerStyle}
      >
        <div className={Style.actionContainer}>
          <div className={Style.actionButton}>
            <a onClick={play} className={Style.actionLink}>
              <span className={Style.iconWrapper}>
                <Icon color="white" icon="play-button" size="large" theme={Style} />
              </span>
              <span className={Style.buttonLabel}>Resume</span>
            </a>
          </div>
          <div className={Style.actionButton}>
            <a onClick={restart} className={Style.actionLink}>
              <span className={Style.iconWrapper}>
                <Icon color="white" icon="restart" size="large" theme={Style} />
              </span>
              <span className={Style.buttonLabel}>{labelRestart}</span>
            </a>
          </div>
        </div>
      </div>
    )
  );
};

export default ResumeWithoutProfile;
